export const PatientCasesMessages = {
  TABS: ['Case Details', 'Case History'],
  PATIENT_CASE_DETAILS: {
    TITLE: 'Patient Case Details',
    SUBTITLE:
      "Explore the patient's healthcare journey through  case history section",
    CASE_ID: 'CASE ID: ',

    HEALTH_STATE: {
      TITLE: 'Current Health State',
      SUBTITLE: 'Information regarding patient health conditions',
    },
    CARE_NAVIGATOR: {
      TITLE: 'Care Navigator',
      SUBTITLE: 'Care Navigator assigned to the patient',
    },
    ENGAGEMENT: {
      TITLE: 'Engagements/ Outreaches',
      SUBTITLE: "Care Navigator's Outreach and Engagement with Member",
    },
  },
  PATIENT_CASE_HISTORY: {
    TITLE: 'Cases Closed',
    SUBTITLE: 'A List member cases  closed',
  },
  PATIENT_ENGAGEMENT_REPORT: {
    TITLE: 'Patient Engagement Report',
    EDIT_SURVEY: 'Edit Survey',
    TABS: ['Engagement Report', 'Case History'],
    SUBTITLE:
      'Showing Patient engage report, Conditions, Comments, Rating & review',
    ENGAGEMENT: {
      TITLE: 'Engagement',
      SUBTITLE:
        "Explore the patient's healthcare journey through  case history section",
    },
    RATING: {
      TITLE: 'Ratings & Review',
      SUBTITLE:
        'The following rating and review given by members for care navigator',
    },
  },
};
